import { Chip } from "@mui/material";

const FilterChip = ({ label, idx, activeIdx, onClick }) => {
  const isActive = idx === activeIdx;


  return (
    <Chip
      label={label}
      onClick={() => onClick(idx,label)}
      sx={{
        background: isActive ? '#1672B9' : 'transparent',
        color: isActive ? '#fff' : '#1672B9',
        border: isActive ? 'none' : '1px solid #1672B9',
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: 300,
        height: '24px',
        width: '60px',
        cursor: 'pointer',

        // base visibility
        opacity: isActive ? 1 : 0.25,

        '& .MuiChip-label': {
          overflow: 'visible',
          whiteSpace: 'nowrap',
        },

        // hover always visible
        '&:hover': {
          opacity: 1,
          backgroundColor: isActive ? '#1672B9' : '#ffffff',
          borderColor: '#1672B9',
        },

        '&:hover .MuiChip-label': {
          color: isActive ? '#fff' : '#1672B9',
        },

        overflow: 'visible',
      }}
    />
  );
};

export default FilterChip;
